import apiClient from "../api/client";
import { PageProperties } from "../types/types";

export async function getPageProperties(
  pageId: string
): Promise<PageProperties | null> {
  try {
    const response = await apiClient.get<PageProperties>(
      "/api/Page/EditPage",
      { params: { Id: pageId } }
    );

    return response.data;
  } catch (error) {
    console.error("Error fetching page properties:", error);
    return null;
  }
}

export async function addPage(
  parentPageGuid: string,
  name: string,
  pageVersionGuid: string,
  createdByGuid: string
): Promise<any> {
  try {
    const response = await apiClient.post("/api/Page/AddPage", {
      ParentPageGuid: parentPageGuid,
      Name: name,
      PageVersionGuid: pageVersionGuid,
      CreatedByGuid: createdByGuid,
    });

    return response.data;
  } catch (error) {
    console.error("Error adding page:", error);
    throw error;
  }
}

export async function removePageAndChildren(
  deleteRequests: { key: string; level: number }[]
) {
  try {
    await apiClient.delete("/api/Page/RemovePageAndChildren", {
      data: deleteRequests,
    });
  } catch (error) {
    throw error;
  }
}

export async function updateSortOrderForAllChildPages(
  sortOrderUpdates: Record<string, number>
): Promise<void> {
  try {
    await apiClient.put(
      "/api/Page/UpdateSortOrderForAllChildPages",
      sortOrderUpdates
    );
  } catch (error) {
    console.error("Error updating sort order:", error);
    throw error;
  }
}

export async function updatePageDetails(payload: {
  Guid: string;
  Name: string;
  MenuGuid: string | null;
  ImageName: string;
  SignatureItem: boolean;
  IsHeroItem: boolean;
  BannerImageUrl: string | null;
  StartTime: string | null;
  EndTime: string | null;
  HeroBadgeText: string | null;
  HeroBadgeStyle: string | null;
}): Promise<void> {
  try {
    await apiClient.put("/api/Page/UpdatePage", payload);
  } catch (error) {
    console.error("Error updating page details:", error);
    throw error;
  }
}

export async function getAllPagesForPageVersionDesigner(
  pageVersionGuid: string
): Promise<any> {
  try {
    const response = await apiClient.get(
      "/api/Page/GetAllPagesForPageVersionDesigner",
      { params: { Id: pageVersionGuid } }
    );

    return response.data;
  } catch (error) {
    console.error("Error fetching pages for designer:", error);
    throw error;
  }
}

export const getMenuTraits = async () => {
  const res = await apiClient.get("/api/Menu/GetAllMenuTraits");
  return res.data;
};

export const getPageTraitByPageId = async (pageId: string) => {
  const res = await apiClient.get(
    "/api/Page/GetPageTraitByPageId",
    {
      params: { pageId },
    }
  );
  return res.data;
};

export const savePageTrait = async (payload: {
  pageGuid: string;
  pageversionGuid: string;
  altName: string;
  altImageUrl: string;
  traitGuid: string;
}) =>
  apiClient.post("/api/Page/SavePageTrait", payload);
